/*
 * Copyright (c) 2023. Haodong JU
 */
import { getStorage, ref } from 'firebase/storage'

import { FireBaseApp } from '@/model/firebase/takewayCompat'

export const FireBaseStorage = getStorage(FireBaseApp)
export const StorageLocation = ref(FireBaseStorage, 'takeaway')
